export const isMonetizationProUser = () => {
  const user = JSON.parse(localStorage.getItem('auth-user'));

  return !!user?.permissions.some(
    (permission) =>
      permission.role_id === 'DASH_CVE_PRO_MONETIZATION_CONFIG' &&
      !!permission.status,
  );
};
